import styled from "styled-components";
import { StyledFormItem } from "../styles";

const SCFormItem = styled(StyledFormItem)`
  &.ant-form-item {
    flex-wrap: wrap;
    flex-direction: column;

    .ant-form-item-label {
      text-align: left;
      display: block;

      > label {
        margin-bottom: 0;
      }
    }
  }
`;

export default SCFormItem;
